import { Navigate, createFileRoute } from "@tanstack/react-router";
import { ProviderInstanceId } from "@afar-research/contracts";

import { ProviderSettingsPanel } from "../components/settings/ProviderSettingsPanel";
import { useSettingsScopeManagedByAfar } from "../hooks/useEnvironmentManagedByAfar";

function SettingsProvidersRoute() {
  const { instanceId } = Route.useSearch();
  // A Cloud Workspace offers no Providers section, so a stale link or a scope switch lands on
  // General instead of a page with nothing to do.
  const managedByAfar = useSettingsScopeManagedByAfar();
  if (managedByAfar) return <Navigate to="/settings/general" replace />;
  return <ProviderSettingsPanel {...(instanceId ? { targetInstanceId: instanceId } : {})} />;
}

export const Route = createFileRoute("/settings/providers")({
  validateSearch: (raw: Record<string, unknown>) =>
    typeof raw.instanceId === "string" && raw.instanceId.trim()
      ? { instanceId: ProviderInstanceId.make(raw.instanceId) }
      : {},
  component: SettingsProvidersRoute,
});
